import React, { useContext } from "react";
import { useSelector } from "react-redux";
import LanguageContext from "../helper/LanguageContext";
import MaterialIcon from "./MaterialIcon";
import {
  companyTrialEndedAskBody,
  companyTrialEndedTitle,
  shouldShowCompanyTrialEndedNote,
} from "../utils/kjuupIoBillingNav";
import { resolveStripeFlags } from "../utils/stripeFeature";
import "./CompanyTrialEndedNote.css";

/**
 * Shown only to company admins who still have a Kjuup.io seat after the
 * company trial fully ended (canceled). Regular employees never see this.
 */
export default function CompanyTrialEndedNote({
  style,
  compact = false,
  className = "",
}) {
  const { strings } = useContext(LanguageContext);
  const profile = useSelector((s) => s.profile);
  const subscription = useSelector((s) => s.subscription) || {};
  const { stripeUiEnabled } = resolveStripeFlags(profile, subscription);
  const show = shouldShowCompanyTrialEndedNote(subscription);

  if (!stripeUiEnabled || !show) return null;

  const title = companyTrialEndedTitle(strings);
  const body = companyTrialEndedAskBody(strings, subscription);

  if (compact) {
    return (
      <div
        className={`kjuup-trial-banner ${className}`.trim()}
        data-testid="companyTrialEndedNote"
        style={style}
      >
        <div className="kjuup-trial-banner__cta company-trial-ended-note__cta">
          <MaterialIcon icon="info" size={16} color="#fff" />
          <span>{body}</span>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`email-empty-state email-empty-state--no-plan company-trial-ended-note ${className}`.trim()}
      data-testid="companyTrialEndedNote"
      style={style}
    >
      <MaterialIcon
        icon="mail"
        size={48}
        color="#737373"
        className="company-trial-ended-note__icon"
      />
      <h4 className="header-margin-gray company-trial-ended-note__title">
        {title}
      </h4>
      <p className="company-trial-ended-note__body">
        {body}
      </p>
    </div>
  );
}

export { formatCompanyAdminNames as formatAdminNames } from "../utils/kjuupIoBillingNav";
